import { gql, useQuery } from "@apollo/client";
import {
  ViewAlertQueryQuery,
  ViewAlertQueryQueryVariables,
} from "../../../../schemaTypes";

export const viewAlertQuery = gql`
  query ViewAlertQuery($alertId: String!) {
    viewAlert(alertId: $alertId) {
        id
        title
        update
        isSeen
        broadcast
        targetMode
        deliveryMode
        locationIds
        locationScopeAll
        communityIds
        communityScopeAll
        targetUserCount
        receivedCount
        queuedCount
        clickCount
        readCount
        unreadCount
        createdBy {
            id
            admin{
                firstname
                lastname
                email
            }
        }
        type
        typeId
        scheduledAt
        dispatchedAt
        selectionSummary {
          targetMode
          userCount
          roles
          userIds
        }
        createdAt
        updatedAt
    }
  }
`;

export function useViewAlert(alertId: string) {
  const { data, loading, error, refetch } = useQuery<
    ViewAlertQueryQuery,
    ViewAlertQueryQueryVariables
  >(viewAlertQuery, {
    variables: { alertId },
    skip: !alertId,
    notifyOnNetworkStatusChange: true,
  });

  const alert = data?.viewAlert
    ? {
        ...data.viewAlert,
        locationIds: data.viewAlert.locationScopeAll ? ["ALL"] : data.viewAlert.locationIds,
        communityIds: data.viewAlert.communityScopeAll ? ["ALL"] : data.viewAlert.communityIds,
      }
    : undefined;

  return {
    alert,
    loading,
    error,
    refetch,
  };
}
